// src/components/AttachmentsSection.jsx
import React, { useState, useEffect, Fragment } from 'react'
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  Typography,
  MenuItem,
  FormControlLabel
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { format } from 'date-fns'
import {
  
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent
} from '@mui/lab'
import { styled } from "@mui/material/styles";
import MuiTimeline from "@mui/lab/Timeline";
import CustomTextField from 'components/mui/text-field'
// import DateRangeCalendar from 'components/DateRangeCalendar'
import AttachmentUpload from 'components/AttachmentUpload'
import AddEmployeeDoodle from "images/AddEmployeeDoodle.png";
import OptionsMenu from 'components/option-menu'
import { Icon } from '@iconify/react'
// import MySwal from 'sweetalert2-react-content'
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import hexToRGBA from 'components/utils/hex-to-rgba'
import { useNavigate } from 'react-router-dom'
import { useUnsavedChanges } from "../../../components/UnsavedChangesContext";
import UnsavedChangesDialog from "components/UnsavedChangesDialog";
import { useTheme } from '@mui/material/styles';
import { dev_baseUrl } from 'utils/var'
import { DownloadAttachments } from "components/logic/DownloadAttachments";

import VideoPlaceholderIcon from 'images/video_placeholder.png';
import CSV_PlaceholderIcon from 'images/Attachment_Icons/CSV__PlaceholderIcon.png';
import PDF_PlaceholderIcon from 'images/Attachment_Icons/PDF_PlaceholderIcon.png';
import DOCX_PlaceholderIcon from 'images/Attachment_Icons/DOCX__PlaceholderIcon.png';
import XLSX_PlaceholderIcon from 'images/Attachment_Icons/XLSX__PlaceholderIcon.png';
import FilePlaceholder from 'images/image_placeholder.png';

const Timeline = styled(MuiTimeline)({
  "& .MuiTimelineItem-root": {
    width: "100%",
    "&:before": { display: "none" },
  },
});


const AttachmentsSection = ({
  entity,
  entityID,
  userName,
  toast,
  employee,
}) => {
  const [ddlArray, setDdlArray]       = useState('selectAll')
  const [openUpload, setOpenUpload]   = useState(false)
  const [uploadFiles, setUploadFiles] = useState([])
  const [btnLoader, setBtnLoader]     = useState(false)
  const [attachments, setAttachments] = useState([])
  const [loading, setLoading]         = useState(false)
  const [grouped, setGrouped]         = useState({})
  const [thumbnails, setThumbnails] = useState({});
  const theme = useTheme();
  const MySwal = withReactContent(Swal);
  const { setHasUnsavedChanges, hasUnsavedChanges } = useUnsavedChanges();
  const [openUnsavedChangesDlg, setOpenUnsavedChangesDlg] = useState(false);
  const [unsavedDialogAction, setUnsavedDialogAction] = useState({
    action: '',
    tabValue: '',
  });

  const navigate = useNavigate();
  // Fetch attachments
  const fetchAttachments = async () => {
    if (!entityID) return
    setLoading(true)
    try {
      const token = localStorage.getItem('jwtToken')
      const res   = await fetch(
        `${dev_baseUrl}/Media/getmedia/Attachment/${entity}/${entityID}/0`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      const data = await res.json()
      if (res.ok && !data.isError) setAttachments(data.result)
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { fetchAttachments() }, [entityID])
  useEffect(() => {
    const g = attachments.reduce((acc, att) => {
      const d = new Date(att.createDate)
      if (!isNaN(d)) {
        const key = format(d, 'MMMM dd, yyyy')
        ;(acc[key] || (acc[key] = [])).push(att)
      }
      return acc
    }, {})
    setGrouped(g)
  }, [attachments])

  // Helpers
  const handleOpen = () => setOpenUpload(true)
  const handleClose = () => {
    if (uploadFiles.length) {    
        setUploadFiles([])
        setOpenUpload(false)    
    } else {
      setOpenUpload(false)
    }
  }

  const getFileType = (filename) => {
    const ext = filename.split('.').pop().toLowerCase();
    if (['mp4', 'mov', 'avi', 'webm', 'mkv'].includes(ext)) return 'video';
    if (['txt', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'json', 'xml'].includes(ext)) return 'text';
    if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(ext)) return 'image';
    return 'other';
  };

  const getAttachmentThumbnail = async (entityID, filename) => {
    const fileExtension = filename.split('.').pop()?.toLowerCase();

    const fileType = getFileType(filename)
    if(fileType === 'video'){
      return VideoPlaceholderIcon;
    }else if (fileType === 'text'){
      if(fileExtension === 'csv'){
        return CSV_PlaceholderIcon
      }else if(fileExtension === 'pdf'){
        return PDF_PlaceholderIcon
      }else if(fileExtension === 'doc' || fileExtension === 'docx'){
        return DOCX_PlaceholderIcon
      }else if(fileExtension === 'xls' || fileExtension === 'xlsx'){
        return XLSX_PlaceholderIcon
      }
    }else if(fileType === 'image'){
      try {
        const blob = await DownloadAttachments('Attachment', entity, entityID, filename, navigate);
        const imgurl = URL.createObjectURL(blob);
  
        return imgurl
      }catch (error){
        console.error("Failed to fetch media thumbnail", error)
      }
    }else{
      return FilePlaceholder
    }
  };

    useEffect(() => {
      const fetchThumbnails = async () => {
        const newThumbnails = {};
        
        for (const date in grouped) {
          for (const attachment of grouped[date]) {
            const imgUrl = await getAttachmentThumbnail(entityID, attachment.fileName);
            newThumbnails[attachment.fileName] = imgUrl;
          }
        }
    
        setThumbnails(newThumbnails);
      };
    
      fetchThumbnails();
    }, [grouped]);

  const downloadAttachment = async (name) => {
    try {
      const result = await DownloadAttachments('Attachment', entity, entityID, name, navigate);

      if (!result || result.form) {
        toast.error(result?.form || 'Failed to download the file', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        return;
      }

      const link = document.createElement('a')
      link.href = URL.createObjectURL(result)
      link.download = name
      link.click();

      setTimeout(() => URL.revokeObjectURL(link.href), 100);

      toast.success(`${name} downloaded successfully.`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
    } catch {
      Swal.fire('Error','Download failed','error')
    }
  }

  const getFileIcon = (fileName) => {
    if (/\.(xlsx|xls)$/i.test(fileName)) return '/images/xlsx.png'
    if (/\.csv$/i.test(fileName))           return '/images/csv.png'
    if (/\.(jpe?g|png|gif)$/i.test(fileName)) return '/images/image_placeholder.png'
    if (/\.pdf$/i.test(fileName))            return '/images/pdf_placeholder.png'
    return '/images/placeholder.png'
  }

  return (
    // <Box>
    <>
      {/* Toolbar */}
      {entity !== "Jobsite" && (<Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: { sm: "flex-end" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
          mb: 3
        }}
      >

        <Button
          onClick={handleOpen}
          variant="contained"
          color="main"
          startIcon={<AddIcon />}
          sx={{ width: { xs: "100%", sm: "auto" } }}
        >
          Add Attachment
        </Button>
      </Box>)}

      <Divider
        sx={{
          color: "text.disabled",
          "& .MuiDivider-wrapper": { px: { xs: 2, sm: 4 } },
          fontSize: theme => theme.typography.body2.fontSize,
          my: theme => `${theme.spacing(3)} !important`
        }}
      />

      <Box>
        {loading ? (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
           <Timeline
              sx={{
                p: 0,
                "& .MuiTimelineItem-root:before": { display: "none" },
              }}
            >
            {attachments.length === 0 ? (
                              <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mx: "auto",
                    border: "1px solid #EAEAEA",
                    borderRadius: 1,
                    width: "100%",
                    height: 280,
                    py: 4,
                    alignItems: "center" ,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                      justifyContent: "center",
                      alignItems: "center",
                      width: { xs: "90%", sm: "100%" }, 
                      maxWidth: 400, 
                      px: 2,
                      textAlign: "center" 
                    }}
                  >
                <img
                  src={AddEmployeeDoodle}
                  alt="Empty State"
                  style={{ width: "100px", height: "auto" }}
                />
                <Typography variant="h6">No attachments added yet</Typography>
              </Box>
            </Box>
            ) : (
              Object.entries(grouped).map(([date, items]) => (
                <Fragment key={date}>
                  {/* <Typography
                    variant={entity === "Jobsite" ? "h6" : "h5"}
                    sx={{ fontWeight: "bold", pl: { xs: 0, sm: 4 } }}
                  >
                    {date}
                  </Typography> */}
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: entity === "Jobsite" ? "normal" : "bold",
                      pl: { xs: 0, sm: 4 },
                      fontSize: entity === "Jobsite" ? '14px' : undefined,
                      color: entity === "Jobsite" ? 'text.primary' : undefined,
                      paddingLeft: `${entity === "Jobsite" ? "16px" : ""}`
                    }}
                  >
                    {date}
                  </Typography>
                  {items.map((attachment, index) => {
                    const d = new Date(attachment.createDate)
                    const t = !isNaN(d.getTime())
                      ? format(d, "hh:mm a")
                      : "Unknown time"

                    const handleDelete = async e => {
                      e.stopPropagation()
                      const { isConfirmed } = await MySwal.fire({
                        title: "<strong>Are you sure?</strong>",
                        html: `<span>This will permanently delete the attachment.</span>`,
                        showCancelButton: true,
                        confirmButtonText: "Yes, delete it!",
                        cancelButtonText: "No, keep it",
                        width: "390px",
                        padding: "1rem",
                        focusConfirm: false,
                        showCloseButton: true,
                        closeButtonHtml: "&times;",
                        customClass: {
                           popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
         cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
                        }
                      })
                      if (!isConfirmed) return

                      try {
                        const token = localStorage.getItem("jwtToken")
                        const res = await fetch(
                          `${dev_baseUrl}/Media/delete/Attachment/${entity}/${entityID}/${attachment.mediaID}`,
                          {
                            method: "DELETE",
                            headers: { Authorization: `Bearer ${token}` }
                          }
                        )
                        const data = await res.json()
                        if (res.ok && !data.isError) {
                          toast.success(data.message || "Deleted successfully.", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: true,
                              theme: "light",
                              style: {
                                fontFamily: '"DM Sans", sans-serif',
                                fontSize: '15px',
                              },
                          })
                          fetchAttachments()
                        } else {
                          toast.error(data.message || "Delete failed.", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: true,
                              theme: "light",
                              style: {
                                fontFamily: '"DM Sans", sans-serif',
                                fontSize: '15px',
                              },
                          })
                        }
                      } catch {
                        toast.error(
                          "An error occurred while deleting. Please try again.",
                          { position: "top-right", autoClose: 5000 }
                        )
                      }
                    }

                    return (
                      <TimelineItem key={attachment.mediaID || index}>
                        <TimelineSeparator>
                          {entity !== "Jobsite" && (<TimelineDot color="error" />)}
                          
                          {index < items.length - 1 && <TimelineConnector />}
                        </TimelineSeparator>
                        <TimelineContent sx={{ py: { xs: 1, sm: 2 },
                          ml: entity === "Jobsite" ? 0 : undefined
                        }}>
                          <Typography
                            variant="caption"
                            sx={{ color: "secondary", fontSize: "12px",
                              
                             }}
                          >
                            {t} — {userName}
                          </Typography>
                          <Box
                            sx={{
                              px: { xs: 2, sm: 6 },
                              py: { xs: 2, sm: 4 },
                              mt: 2,
                              display: "flex",
                              flexDirection: { xs: "column", sm: "row" },
                              justifyContent: "space-between",
                              alignItems: { xs: "flex-start", sm: "center" },
                              border: "1px solid #D9D9D9",
                              borderRadius: 2,
                              width: { xs: "100%", sm: `${entity === "Jobsite" ? "100%" : "80%"}`, md: `${entity === "Jobsite" ? "100%" : "40%"}` },
                              gap: { xs: 2, sm: 0 }
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                width: { xs: "100%", sm: "auto" }
                              }}
                            >
                              <img
                                width={50}
                                height={50}
                                alt={attachment.fileName || "attachment"}
                                loading="lazy"
                                src={
                                  thumbnails[attachment.fileName] ||
                                  "/images/ImageLoader.gif"
                                }
                                style={{ objectFit: "cover" }}
                              />
                            <Typography
                              variant="body2"
                              sx={{
                                ml: 2,
                                wordBreak: "break-word",
                                whiteSpace: "normal", // allow multi-line
                                overflowWrap: 'anywhere',
                                maxWidth: entity === "Jobsite" ? '100%' : '250px' // full width on Jobsite
                              }}
                            >
                              {attachment.fileName}
                            </Typography>
                            </Box>
                            <OptionsMenu
                              iconButtonProps={{
                                size: "small",
                                sx: {
                                  color: "text.secondary",
                                  p: 0.3,
                                  borderRadius: "50%",
                                  "&:hover": {
                                    backgroundColor: theme =>
                                      theme.palette.action.hover,
                                    borderRadius: "50%"
                                  }
                                }
                              }}
                              options={[
                                {
                                  text: (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2
                                      }}
                                    >
                                      <Icon icon="tabler:download" />
                                      Download
                                    </Box>
                                  ),
                                  menuItemProps: {
                                    onClick: () =>
                                      downloadAttachment(attachment.fileName)
                                  }
                                },
                                {
                                  text: (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                        color: "error.main" 
                                      }}
                                    >
                                      <Icon icon="tabler:trash" />
                                      Delete
                                    </Box>
                                  ),
                                  menuItemProps: { onClick: handleDelete }
                                }
                              ]}
                            />
                          </Box>
                        </TimelineContent>
                      </TimelineItem>
                    )
                  })}
                </Fragment>
              ))
            )}
          </Timeline>
        )}
      </Box>

      {/* Upload dialog */}
      <AttachmentUpload
        open={openUpload}
        handleClose={handleClose}
        Title="Upload Attachment"
        files={uploadFiles}
        btnLoader={btnLoader}
        setUploadFiles={setUploadFiles}
        setFiles={setUploadFiles}
        setBtnLoader={setBtnLoader}
        navigate={navigate}
        entity={entity.toLowerCase()}
        payload={employee}
        setOpenUploadDlg={setOpenUpload}
        fetchAttachments={fetchAttachments}
        attachments={attachments}
      />
    {/* </Box> */}
    </>
  )
}

export default AttachmentsSection
